import React from 'react'
import {useTranslation} from 'react-i18next'

import {Overlay, MessageContainer} from './ProcessingOverlay.styled'
import {Typography} from '../typography/Typography'
import {Loading} from '../loading/Loading'

type ProcessingOverlayProps = {
  isVisible: boolean
}

export const ProcessingOverlay: React.FC<ProcessingOverlayProps> = ({
  isVisible,
}) => {
  const {t} = useTranslation()

  if (!isVisible) return null

  return (
    <Overlay flex justify="center" align="center">
      <MessageContainer flex direction="column" align="center" spacing={2}>
        <Loading />
        <Typography size="lg" weight="medium">
          {t('Processing information, please wait...')}
        </Typography>
      </MessageContainer>
    </Overlay>
  )
}
